<script setup lang="ts">
import { WAIVER_FORM_CONTAINER_CLASS, WAIVER_FORM_PAGE_INSET_CLASS } from 'ui/util/waiver/constants';

withDefaults(defineProps<{
  fields?: number;
  inset?: boolean;
}>(), {
  fields: 4,
  inset: true,
});
</script>

<template>
  <div :class="inset ? WAIVER_FORM_PAGE_INSET_CLASS : undefined">
    <div
      :class="WAIVER_FORM_CONTAINER_CLASS"
      role="status"
      aria-busy="true"
      data-cy="waiver-form-skeleton"
    >
      <span class="sr-only">Loading form</span>
      <div aria-hidden="true" class="flex flex-col gap-8">
        <div class="flex flex-col gap-3">
          <USkeleton class="h-7 w-2/3" />
          <USkeleton class="h-4 w-full" />
          <USkeleton class="h-4 w-4/5" />
        </div>
        <div
          v-for="field in fields"
          :key="field"
          data-cy="waiver-form-skeleton-field"
          class="flex flex-col gap-2"
        >
          <USkeleton class="h-4 w-40" />
          <USkeleton class="h-12 w-full" />
        </div>
        <div class="flex justify-end">
          <USkeleton class="h-11 w-28" />
        </div>
      </div>
    </div>
  </div>
</template>
